/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   SearchForm
 */

/** @jsx jsx */
import { jsx } from '@emotion/react'
import type { AutocompleteApiResult, AutocompleteCurrentPositionResult } from '@zcode/bizos'
import { HomepageAutocomplete } from '../../../HomepageAutocomplete/HomepageAutocomplete'
import { NEW_AUTOCOMPLETE_PLACEHOLDER } from '../../constants'
import * as styles from './style'

import theme from './shortTermTheme.module.scss'

export interface SearchFormProps {
  onSelectResult: (
    result: AutocompleteApiResult | AutocompleteCurrentPositionResult
  ) => Promise<void>
}

export const SearchForm = ({ onSelectResult }: SearchFormProps) => {
  return (
    <div css={styles.formContainer}>
      <div css={[styles.autocompleteContainer]}>
        <HomepageAutocomplete
          onSelectAutocompleteResult={onSelectResult}
          origin="homepage-hero"
          placeholder={NEW_AUTOCOMPLETE_PLACEHOLDER}
          theme={theme}
        />
      </div>
    </div>
  )
}
